var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { forEach, get, kebabCase, isNumber, isObject, isUndefined, set, size, union } from 'lodash';
import { Stratus } from '@stratusjs/runtime/stratus';
import { sanitize } from '@stratusjs/core/conversion';
import { flatten, isJSON, poll, ucfirst } from '@stratusjs/core/misc';
import { cookie } from '@stratusjs/core/environment';
import { getInjector } from '../injector';
import { Model, ModelOptionKeys } from './model';
import { Collection, CollectionOptionKeys } from './collection';
import { EventManager } from '@stratusjs/core/events/eventManager';
let injector = getInjector();
let $interpolate;
const serviceVerify = () => __awaiter(void 0, void 0, void 0, function* () {
    return new Promise((resolve, _reject) => __awaiter(void 0, void 0, void 0, function* () {
        if ($interpolate) {
            resolve(true);
            return;
        }
        if (!injector) {
            injector = getInjector();
        }
        if (injector) {
            $interpolate = injector.get('$interpolate');
        }
        if ($interpolate) {
            resolve(true);
            return;
        }
        setTimeout(() => {
            if (cookie('env')) {
                console.log('wait for $interpolate service:', $interpolate);
            }
            serviceVerify().then(resolve);
        }, 250);
    }));
});
export class Registry {
    constructor() {
    }
    fetch($element, $scope) {
        return new Promise((resolve, _reject) => __awaiter(this, void 0, void 0, function* () {
            if (typeof $element === 'string') {
                $element = {
                    target: $element
                };
            }
            const inputs = {};
            const baseInputs = [
                'id',
                'api',
                'temp',
                'decouple',
                'fetch'
            ];
            forEach(union(ModelOptionKeys, CollectionOptionKeys, baseInputs), (option) => set(inputs, option, 'data-' + kebabCase(option)));
            const options = forEach(inputs, (value, key, list) => {
                list[key] = $element.attr ? $element.attr(value) : $element[key];
                if (!isJSON(list[key])) {
                    return;
                }
                list[key] = JSON.parse(list[key]);
            });
            options.api = sanitize(options.api);
            options.temp = sanitize(options.temp);
            let completed = 0;
            const verify = () => {
                if (!isNumber(completed) || completed !== size(options)) {
                    return;
                }
                resolve(this.build(options, $scope));
            };
            if (!$interpolate) {
                yield serviceVerify();
            }
            forEach(options, (element, key) => __awaiter(this, void 0, void 0, function* () {
                if (!element || typeof element !== 'string' || !$scope || !$scope.$parent) {
                    completed++;
                    verify();
                    return;
                }
                const interpreter = $interpolate(element, false, null, true);
                const initial = interpreter($scope.$parent);
                if (typeof initial !== 'undefined') {
                    options[key] = initial;
                    completed++;
                    verify();
                    return;
                }
                if (cookie('env')) {
                    console.log(`poll (${key}): start`);
                }
                let value;
                try {
                    value = yield poll(() => interpreter($scope.$parent), 1500, 250);
                }
                catch (err) {
                    if (cookie('env') ||
                        err.name !== 'Timeout') {
                        console.error(err);
                    }
                }
                if (cookie('env')) {
                    console.log(`poll (${key}):`, value);
                }
                options[key] = value;
                completed++;
                verify();
            }));
        }));
    }
    build(options, $scope) {
        let data;
        if (options.payload || options.convoy) {
            options.fetch = false;
        }
        if (options.target) {
            options.target = ucfirst(options.target);
            if (options.manifest || options.id) {
                if (!Stratus.Catalog[options.target]) {
                    Stratus.Catalog[options.target] = {};
                }
                const id = options.id || 'manifest';
                if (options.decouple || !Stratus.Catalog[options.target][id]) {
                    const modelOptions = {
                        stagger: true
                    };
                    forEach(ModelOptionKeys, (element) => {
                        const optionValue = get(options, element);
                        if (isUndefined(optionValue)) {
                            return;
                        }
                        set(modelOptions, element, optionValue);
                    });
                    data = new Model(modelOptions, {
                        id: options.id
                    });
                    if (!options.decouple) {
                        Stratus.Catalog[options.target][id] = data;
                    }
                }
                else if (Stratus.Catalog[options.target][id]) {
                    data = Stratus.Catalog[options.target][id];
                }
            }
            else {
                const registry = !options.direct ? 'Catalog' : 'Compendium';
                if (!Stratus[registry][options.target]) {
                    Stratus[registry][options.target] = {};
                }
                if (options.decouple ||
                    !Stratus[registry][options.target].collection) {
                    const collectionOptions = {};
                    forEach(CollectionOptionKeys, (element) => {
                        const optionValue = get(options, element);
                        if (isUndefined(optionValue)) {
                            return;
                        }
                        set(collectionOptions, element, optionValue);
                    });
                    data = new Collection(collectionOptions);
                    if (!options.decouple) {
                        Stratus[registry][options.target].collection = data;
                    }
                }
                else if (Stratus[registry][options.target].collection) {
                    data = Stratus[registry][options.target].collection;
                }
            }
            if (options.api) {
                data.meta.set('api', isJSON(options.api) ? JSON.parse(options.api) : options.api);
            }
            if (options.temp && isObject(options.temp) && !data.completed) {
                forEach(flatten(options.temp), (v, k) => {
                    console.log('setting temp:', `api.${k}`, v);
                    data.meta.temp(`api.${k}`, v);
                });
            }
            if (data instanceof Model && data.stagger && typeof data.initialize === 'function') {
                data.initialize();
            }
        }
        if (typeof data === 'object' && data !== null) {
            if (typeof $scope !== 'undefined') {
                $scope.data = data;
                if (data instanceof Model) {
                    $scope.model = data;
                }
                else if (data instanceof Collection) {
                    $scope.collection = data;
                }
                if (data instanceof EventManager && typeof $scope.$applyAsync === 'function') {
                    data.on('change', () => {
                        $scope.$applyAsync();
                    });
                    data.on('error', () => {
                        $scope.$applyAsync();
                    });
                    if (data.completed) {
                        $scope.$applyAsync();
                    }
                }
            }
            if (!data.pending
                && !data.completed
                && (isUndefined(options.fetch) || options.fetch)) {
                data.fetch().then();
            }
        }
        return data;
    }
}
Stratus.Services.Registry = [
    '$provide',
    ($provide) => {
        $provide.factory('Registry', [
            () => {
                return new Registry();
            }
        ]);
    }
];
Stratus.Data.Registry = Registry;

//# sourceMappingURL=registry.js.map
